import { Label, Button, Grid, InputAdornment, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { LoadingButton } from '@mui/lab';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { Box, height } from '@mui/system';
import { Field, Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadGridSupplier } from '../../helpers/loadGrid';
import { setActiveSupplier, startUpdateSupplier } from '../../redux/actions/suppliers';
import { useFormStyles } from '../../styles/formStyles';
import { validationSchemaSupplier } from '../../utils/schemaValidationForm';
import { FormikDatePicker } from '../ui/FormikDatePicker';
import esLocale from 'date-fns/locale/es';
import { useParams } from '@reach/router';
import { navigate } from '@reach/router';
import { SwitchMUI } from '../ui/Switch';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export const SupplierInfo = () => {
  const classes = useFormStyles(); //we load the styles from the useForm arrow function
  const dispatch = useDispatch(); //react-redux hook to be able to dispatch the actions
  const { active } = useSelector(state => state.supplier);
  const { menuState } = useSelector(state => state.ui);
  const { data } = loadGridSupplier();
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down('md'));
  const params = useParams();
  const result = data.filter(item => item?.type !== 'detail');

  useEffect(() => {
    dispatch(setActiveSupplier(params.PkProveedores));
  }, [dispatch, params.PkProveedores]);

  const initialValues = {
    Nombre: active?.Nombre,
    Email: active?.Email,
    Telefono: active?.Telefono,
    PaginaWeb: active?.PaginaWeb,
    Observaciones: active?.Observaciones,
    date: active?.FechaBaja,
    UsaTextoVoucher: active?.UsaTextoVoucher,
    TextoVoucher: active?.TextoVoucher || '',
    ProveedorFueraUE: active?.ProveedorFueraUE,
    ReemplazarNombreProveedor: active?.ReemplazarNombreProveedor,
  };

  const handleSubmit = (values, { setSubmitting }) => {
    const newSupplier = {
      PkProveedores: active.PkProveedores,
      Nombre: values.Nombre,
      Email: values.Email,
      Telefono: values.Telefono,
      PaginaWeb: values.PaginaWeb,
      Observaciones: values.Observaciones,
      FechaBaja: values.date ? values.date : null,
      VersionFila: active?.VersionFila,
      UsaTextoVoucher: values.UsaTextoVoucher,
      TextoVoucher: values.TextoVoucher || '',
      ProveedorFueraUE: values.ProveedorFueraUE,
      ReemplazarNombreProveedor: values.ReemplazarNombreProveedor,
    };
    dispatch(startUpdateSupplier(newSupplier, setSubmitting));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchemaSupplier}
        onSubmit={handleSubmit}>
        {({ handleChange, errors, values, handleBlur, isSubmitting, touched, isValid, setFieldValue }) => (
          <Grid md={6} xs={11}>
            <Form>
              <Typography style={{ padding: '1rem', marginBottom: '1rem' }} variant="h1">
                Proveedor
              </Typography>

              <Grid container spacing={3}>
                <Grid item md={12} classes={{ root: classes.container }}>
                  <SwitchMUI
                    label="Proveedor fuera de la UE"
                    name="ProveedorFueraUE"
                    values={values}
                    setFieldValue={setFieldValue}
                    style={undefined}
                  />
                </Grid>
                {result.map(element => {
                  return (
                    <Grid key={element.name} item md={6} xs={12}>
                      <TextField
                        fullWidth
                        name={element.name}
                        size="small"
                        classes={{ root: classes.inputText }}
                        id={`outlined-basic-${element.name}`}
                        label={element.label}
                        variant="outlined"
                        InputProps={{
                          startAdornment: <InputAdornment position="start">{element.startAdornment}</InputAdornment>,

                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        value={values[element.name]}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched[element.name] && Boolean(errors[element.name])}
                        helperText={touched[element.name] && errors[element.name]}
                        disabled={isSubmitting}
                        multiline={element.name === 'Observaciones' ? true : false}
                        maxRows={element.name === 'Observaciones' ? 10 : undefined}
                        minRows={element.name === 'Observaciones' ? 5 : undefined}
                      />
                    </Grid>
                  );
                })}
                <Grid item md={6} xs={12}>
                  <Field
                    style={{ fontSize: '0.8em' }}
                    component={FormikDatePicker}
                    name="date"
                    label="Fecha Baja"
                    textfield="date"
                    isSubmitting={isSubmitting}
                    value={values?.Fechabaja}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <SwitchMUI
                    label="Utilizar texto Voucher personalizado"
                    name="UsaTextoVoucher"
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <SwitchMUI
                    label="Reemplazar nombre en Voucher"
                    name="ReemplazarNombreProveedor"
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                </Grid>
              </Grid>

              <Grid item md={12} xs={12}>
                <CKEditor
                  config={{
                    toolbar: {
                      items: ['bold', 'italic', '|', 'undo', 'redo', '-', 'numberedList', 'bulletedList'],

                      shouldNotGroupWhenFull: true,
                    },
                  }}
                  editor={ClassicEditor}
                  data={values.TextoVoucher}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                  }}
                  onChange={(_, editor) => {
                    const data = editor.getData();
                    setFieldValue('TextoVoucher', data);
                  }}
                />
              </Grid>

              <Box
                sx={{
                  marginTop: '20px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: '2',
                }}>
                <Button
                  style={{
                    marginRight: '20px',
                    backgroundColor: '#F39868',
                    color: '#fff',
                    borderRadius: 7,
                    marginLeft: 10,
                  }}
                  onClick={() => navigate('/suppliers')}>
                  Cancelar
                </Button>
                <LoadingButton
                  loadingPosition="start"
                  variant="contained"
                  type="submit"
                  loading={isSubmitting}
                  disabled={!isValid}
                  style={{
                    backgroundColor: '#E5824F',
                  }}>
                  Actualizar
                </LoadingButton>
              </Box>
            </Form>
          </Grid>
        )}
      </Formik>
    </LocalizationProvider>
  );
};
